import React, { useContext } from 'react'
import { StyleProp, StyleSheet, Text, View, ViewStyle } from 'react-native'
import { Separator } from '../../../components/Separator'
import { Calendar, Clock, Hashtag, Location } from '../../../components/Svg'
import { lightBackground, textColor, toqueColor } from '../../../theme/colors'
import { NecropsyContext } from '../../../context/Necropsy/Provider'
import { useTranslation } from 'react-i18next'

interface Props {
  title: string
  hasTime?: boolean
  customStyle?: StyleProp<ViewStyle>
  hasBg?: boolean
  config?: {
    centerName: string
    formId: string
    date: string
  }
  hasCaseNumber?: boolean
}

export const FormHeader = ({
  title,
  hasTime,
  customStyle,
  hasBg,
  config,
  hasCaseNumber,
}: Props) => {
  const { form } = useContext(NecropsyContext)
  const { t } = useTranslation()
  return (
    <View style={[hasBg && { backgroundColor: lightBackground }, customStyle]}>
      <Text style={[styles.text, { fontWeight: '500' }]}>{title}</Text>
      <Separator customStyle={styles.separator} />

      <View style={styles.container}>
        <Location width={25} height={25} />
        <Text style={styles.text}>
          {t('Centro')}: {form.centerName ?? config?.centerName}
        </Text>
      </View>
      {hasCaseNumber && (
        <View style={styles.container}>
          <Hashtag width={25} height={25} />
          <Text style={styles.text}>
            {t('Ficha N')}: {form.formId ?? config?.formId}
          </Text>
        </View>
      )}
      <View style={styles.container}>
        <Calendar width={25} height={25} />
        <Text style={styles.text}>
          {t('Fecha')}: {form.date ?? config?.date}
        </Text>
      </View>
      {hasTime && (
        <View style={styles.container}>
          <Clock width={25} height={25} />
          <Text style={styles.text}>
            {t('Hora')}: {form.time}
          </Text>
        </View>
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  separator: {
    borderBottomWidth: 3,
    width: 31,
    borderBottomColor: toqueColor,
    marginBottom: 24,
    marginTop: 10,
  },
  text: {
    color: textColor,
    fontWeight: '400',
    fontSize: 16,
  },
})
